export const products = [
    {
        id: 1,
        image: "./images/Apple_Macbook_Air.png",
        title: "Philips Hue 7W BR30 Connected Downlight Lamp",
        price: 249,
        unitprice: 300,
        quantity: 1,
    },
    {
        id: 2,
        image: "./images/Apple Ipad.png",
        title: "Philips Hue 7W BR30 Connec ted Downlight Lamp",
        price: 299,
        unitprice: 345,
        quantity: 1,
    }
    ,
    {
        id: 3,
        image: "../images/Apple_Macbook_Air.png",
        title: "Philips Hue 7W BR30 Connec ted Downlight Lamp",
        price: 299,
        unitprice: 345,
        quantity: 1,
    },
    {
        id: 4,
        image: "./downloadImages/ipad13.jpg",
        title: "Philips Hue 7W BR30 Connected Downlight Lamp",
        price: 249,
        unitprice: 300,
        quantity: 1,
    },
    {
        id: 5,
        image: "./images/Apple_Macbook_Air.png",
        title: "Philips Hue 7W BR30 Connec ted Downlight Lamp",
        price: 299,
        unitprice: 345,
        quantity: 1,
    }
    ,
    {
        id: 6,
        image: "./asset/products/apple_iPod_2A.png",
        title: "Philips Hue 7W BR30 Connec ted Downlight Lamp",
        price: 299,
        unitprice: 345,
        quantity: 1,
    }
]